import React from 'react';
import { useTable } from 'react-table';
import './table-content.scss';
import Skeleton from 'react-loading-skeleton';

interface TableContentProps {
  columns: any[];
  data: any[];
  isLoading?: boolean;
}

const TableContent: React.FC<TableContentProps> = ({ columns, data, isLoading = false }) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
  });

  return (
    <div className="table-container">
      <table {...getTableProps()} className="custom-table">
        <thead>
          {headerGroups.map((headerGroup) => {
            const { key, ...headerGroupProps } = headerGroup.getHeaderGroupProps();
            return (
              <tr key={key} {...headerGroupProps}>
                {headerGroup.headers.map((column) => {
                  const { key: columnKey, ...columnProps } = column.getHeaderProps();

                  const classNames = (column as any).className || '';

                  return (
                    <th key={columnKey} {...columnProps} className={classNames}>
                      {column.render('Header')}
                    </th>
                  );
                })}
              </tr>
            );
          })}
        </thead>
        <tbody {...getTableBodyProps()}>
          {isLoading ? (
            Array.from({ length: 5 }).map((_, i) => (
              <tr key={`skeleton-row-${i}`}>
                {columns.map((_, j) => (
                  <td key={`skeleton-cell-${i}-${j}`}>
                    <Skeleton width="100%" height={20} highlightColor="#007bff"   />
                  </td>
                ))}
              </tr>
            ))
          ) : (
            rows.map((row) => {
              prepareRow(row);
              const { key: rowKey, ...rowProps } = row.getRowProps();
              return (
                <tr key={rowKey} {...rowProps}>
                  {row.cells.map((cell) => {
                    const { key: cellKey, ...cellProps } = cell.getCellProps();
                    return (
                      <td key={cellKey} {...cellProps}>
                        {cell.render('Cell')}
                      </td>
                    );
                  })}
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TableContent;
